import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueMeta from 'vue-meta'
import VueAnalytics from 'vue-analytics'
import SocialSharing from 'vue-social-sharing'
import VueI18n from 'vue-i18n'
import { data } from '@/lib/lang/index.js'

// ----- firebase -----
// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from 'firebase/app'
// Add the Firebase products that you want to use
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/analytics'
const firebaseConfig = {
  apiKey: 'AIzaSyDYodppZaJuHwoI-Gpw-CxlNdJsmOIMW0U',
  authDomain: 'diagram-f4549.firebaseapp.com',
  databaseURL: 'https://diagram-f4549.firebaseio.com',
  projectId: 'diagram-f4549',
  storageBucket: 'diagram-f4549.appspot.com',
  messagingSenderId: '70951955869',
  appId: '1:70951955869:web:0f12f085c02698f2d9d374',
  measurementId: 'G-V4NYQ882MV'
}
firebase.initializeApp(firebaseConfig)
firebase.analytics()
// ----- /firebase -----

Vue.config.productionTip = false

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ja', // デフォルト言語設定
  fallbackLocale: 'en', // 選択中の言語に対応する文字列が存在しない場合はこの言語の文字列を使用する
  messages: data
})

Vue.use(SocialSharing)
Vue.use(VueMeta)

Vue.use(VueAnalytics, {
  id: 'UA-37365118-2',
  router
})

new Vue({
  i18n,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
